module.exports = __webpack_public_path__ + "img/logo-inverse.c6441d15.png";